import { render, staticRenderFns } from "./signal.vue?vue&type=template&id=275b1b36&scoped=true"
import script from "./signal.vue?vue&type=script&lang=js"
export * from "./signal.vue?vue&type=script&lang=js"
import style0 from "./signal.vue?vue&type=style&index=0&id=275b1b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b1b36",
  null
  
)

export default component.exports